import { render, staticRenderFns } from "./PageHeadingInfo.vue?vue&type=template&id=7b18940a&scoped=true&"
import script from "./PageHeadingInfo.vue?vue&type=script&lang=js&"
export * from "./PageHeadingInfo.vue?vue&type=script&lang=js&"
import style0 from "./PageHeadingInfo.vue?vue&type=style&index=0&id=7b18940a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b18940a",
  null
  
)

export default component.exports